let token = new URLSearchParams(window.location.search).get("token");
if(token !== undefined && token !== null){
    localStorage.setItem("token", JSON.stringify(token));
}else{
    token = localStorage.getItem("token")
    if (token === 'null'){
        token = null
    }
}

const auth = {
    install(app){
        app.config.globalProperties.$auth = token;
    }
}

export default auth